import MetaTagCard from "../../components/ProductManager/MetaTagCard";

const ProductMetaTags = (props) => {
    return <MetaTagCard />
}

export default ProductMetaTags;